
/* Exceptions for parsing TuringMachine */
export class TmParsingException extends Error {
    #errors     // TmParsingError[]

    /**
     * @param errors {TmParsingError[]}
     * @param message {string}
     */
    constructor(errors, message) {
        super(message);
        this.#errors = errors;
        this.name = 'TmParsingException';
    }

    get errors(){
        return this.#errors;
    }

    toString(){
        let str = `${this.message}:`;
        this.#errors.forEach(e => {
            str += `\n${e.part}:\t\t ${e.description}`;
        });

        return str;
    }
}

// if lineIndex===undefined, then error is not related to any specific line
// part can be: 'alphabet-input', 'state-input-name'
export class TmParsingError {
    #part           // string, what part of TM (alphabet/states, etc.) this error is related to
    #lineIndex      // number, zero-based index
    #description;   // string

    /**
     * @param part {string} what part of TM (alphabet/states, etc.) this error is related to
     * @param lineIndex {number|undefined} zero-based line index.
     * If the error not refers to specific line, it should be <code>undefined</code>.
     * @param description {string} description of the error
     */
    constructor(part, lineIndex, description) {
        this.#part = part;
        this.#lineIndex = lineIndex;
        this.#description = description;
    }

    get part() {
        return this.#part;
    }

    get lineIndex() {
        return this.#lineIndex;
    }

    get description() {
        return this.#description;
    }
}


/* Exceptions for compiling UrmProgram */
export class UrmProgramCompilingException extends Error {
    #errors     // UrmProgramCompilingError[]

    /**
     *
     * @param message
     * @param errors {UrmProgramCompilingError[]}
     */
    constructor(errors, message) {
        super(message);
        this.#errors = errors;
        this.name = 'UrmProgramCompilingException';
    }

    get errors(){
        return this.#errors;
    }

    toString(){
        let str = `${this.message}:`;
        this.#errors.forEach(e => {
            str += `\nline ${e.lineIndex+1}:\t\t ${e.description}`;
        });

        return str;
    }
}

// if lineIndex===-1, then error is about entire program (not specific line)
export class UrmProgramCompilingError {
    #lineIndex // zero-based index
    #description;

    /**
     *
     * @param lineIndex {number} zero-based line index.
     * If the error refers to the entire URM program (and not to a specific line), it should be -1.
     * @param description {string}
     */
    constructor(lineIndex, description) {
        this.#lineIndex = lineIndex;
        this.#description = description;
    }

    get lineIndex() {
        return this.#lineIndex;
    }

    get description() {
        return this.#description;
    }
}

/* General excepions */
export class InvalidArgumentException extends Error {
    constructor(message) {
        super(message);
        this.name = 'InvalidArgumentException';
    }
}

export class IndexOutOfBoundsException extends Error {
    constructor(message) {
        super(message);
        this.name = 'IndexOutOfBoundsException';
    }
}

export class IllegalStateException extends Error {
    constructor(message) {
        super(message);
        this.name = 'IllegalStateException';
    }
}